// src/components/settings/sections/CompanyInfoSection.jsx
import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormInput from '../../inputs/FormInput';
import { getAccordionStyles } from './accordionStyles';

const CompanyInfoSection = ({
    expanded,
    handleAccordionChange,
    isDark,
    formData,
    handleTextChange,
    showArabic,
    showEnglish,
    hasError
}) => {
    const { accordionBaseSx, summarySx, detailsSx } = getAccordionStyles(isDark);

    return (
        <Accordion
            expanded={expanded === 'company'}
            onChange={handleAccordionChange('company')}
            disableGutters
            elevation={0}
            square={false}
            sx={{
                ...accordionBaseSx,
                border: hasError
                    ? '2px solid #EF4444'
                    : (accordionBaseSx.border || '1px solid rgba(0, 0, 0, 0.12)'),
                '&:hover': {
                    ...(accordionBaseSx['&:hover'] || {}),
                    borderColor: hasError
                        ? '#DC2626'
                        : (accordionBaseSx['&:hover']?.borderColor || 'rgba(0, 0, 0, 0.23)'),
                },
                transition: 'all 0.3s ease'
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{
                    color: hasError ? '#EF4444' : (isDark ? '#93C5FD' : '#1D4ED8')
                }} />}
                sx={{
                    ...summarySx,
                    backgroundColor: hasError
                        ? (isDark ? 'rgba(239, 68, 68, 0.1)' : 'rgba(254, 226, 226, 1)')
                        : summarySx.backgroundColor,
                    transition: 'background-color 0.3s ease'
                }}
            >
                <Typography
                    fontWeight={600}
                    sx={{
                        color: hasError ? '#EF4444' : (isDark ? '#E5E7EB' : '#0F172A'),
                        fontSize: 15,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}
                >
                    Company Info
                    {hasError && <span style={{ fontSize: '18px' }}>⚠️</span>}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={detailsSx}>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 1 }}>
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="name_ar"
                                label="اسم الشركة (عربي)"
                                labelBio="ادخل اسم الشركة بالعربي"
                                value={formData.name_ar}
                                onChange={handleTextChange}
                                fullWidth
                                required
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="name_en"
                                label="Company Name (EN)"
                                labelBio="Enter company name in English"
                                value={formData.name_en}
                                onChange={handleTextChange}
                                fullWidth
                                required
                            />
                        </Box>
                    )}
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="main_location_ar"
                                label="الموقع الرئيسي (عربي)"
                                labelBio="ادخل المدينة/الدولة بالعربي"
                                value={formData.main_location_ar}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="main_location_en"
                                label="Main Location (EN)"
                                labelBio="Enter city / country in English"
                                value={formData.main_location_en}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="address1_ar"
                                label="العنوان الأول (عربي)"
                                labelBio="العنوان الأول بالعربي"
                                value={formData.address1_ar}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="address1_en"
                                label="Address 1 (EN)"
                                labelBio="First address in English"
                                value={formData.address1_en}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showArabic && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="address2_ar"
                                label="العنوان الثاني (عربي)"
                                labelBio="العنوان الثاني بالعربي"
                                value={formData.address2_ar}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                    {showEnglish && (
                        <Box sx={{ flex: 1, minWidth: 220 }}>
                            <FormInput
                                type="text"
                                name="address2_en"
                                label="Address 2 (EN)"
                                labelBio="Second address in English"
                                value={formData.address2_en}
                                onChange={handleTextChange}
                                fullWidth
                                required={false}
                            />
                        </Box>
                    )}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};

export default CompanyInfoSection;
